import React from 'react';

const Warning = () => {
  return (
    <>
      <h1 className="warning">We are currently working on a solution</h1>
      <style>{`
        .warning {
          text-align: center;
          font-family: 'Roboto-Normal';
        }
      `}</style>
    </>
  );
};

export default Warning;
